(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/shared/assets/javascripts/api.js') >= 0) return;  svs.modules.push('/components/content/shared/assets/javascripts/api.js'); 'use strict';

var apiUtils = svs.content.shared;

function responseFilter(resp) {
  if (!resp) {
    return resp;
  }

  var blacklist = ['parentId', 'parentName', 'rank', 'version'];
  var validTypes = ['cnt:authorProfile', 'cnt:drawAnalysis', 'cnt:gameAnalysis'];

  if (!resp.result) {
    return resp;
  }

  var results = resp.result;
  results.forEach(function (result, index) {
    if (validTypes.indexOf(result.contentType) > -1) {
      results[index] = JSON.parse(JSON.stringify(result).split('domainCategories').join('gameinfo'), function (key, value) {
        if (key === 'gameinfo') {
          var gameinfo = {};
          value.forEach(function (item) {
            var itemValue = item.split('/')[1];
            var itemKeyName = item.split('svs-domain-')[1].split('/')[0];

            if (!gameinfo[itemKeyName]) {
              gameinfo[itemKeyName] = [];
            }

            gameinfo[itemKeyName].push(Number(itemValue));
          });
          return gameinfo;
        } else if (blacklist.indexOf(key) > -1) {
          return undefined;
        }

        return value;
      });
    }
  });
  resp.result = results;
  return resp;
}


function basicFilter(filter, callback) {
  var validationError = apiUtils.validateOptions(filter, ['type']);

  if (validationError) {
    if (callback && typeof callback === 'function') {
      callback(validationError);
      return;
    } 


    return $.Deferred().reject(validationError);
  }

  var params = {
    channel: svs.core.data.capabilities.channel,
    contentType: filter.type,
    count: filter.count || 1,
    domainCategories: filter.domainCategories,
    include: filter.include,
    matchAllDomainCategories: filter.matchAllDomainCategories,
    modifiedSince: filter.modifiedSince,
    offset: filter.offset || 0,
    orderBy: filter.orderBy,
    parentId: filter.parentId,
    sortOrder: filter.sortOrder
  };
  apiUtils.appendUserParams(params);
  var cbk;

  if (callback) {
    cbk = function cbk(err, resp) {
      callback(err, responseFilter(resp));
    };

    return apiUtils.callJupiter(new apiUtils.ContentUrlBuilder('basicfilter', filter.routesDomain).addParams(params).build(), cbk);
  }

  return apiUtils.callJupiter(new apiUtils.ContentUrlBuilder('basicfilter', filter.routesDomain).addParams(params).build()) 
  .then(function (resp) {
    return $.Deferred().resolve(responseFilter(resp));
  }) 
  .catch(function (err) {
    return $.Deferred().reject(err);
  });
}


function getGameAnalyses(filter, callback) {
  var domainCategories = [];

  if (filter.id) {
    if (filter.idType === 'match') {
      domainCategories.push("svs-domain-sport-events/".concat(filter.id));
    } else if (filter.idType === 'race') {
      domainCategories.push("svs-domain-sport-events-racing/".concat(filter.id));
    } else {
      if (callback && typeof callback === 'function') {
        callback("unsupported idType: ".concat(filter.idType));
        return;
      } 


      return $.Deferred().reject("unsupported idType: \"".concat(filter.idType, "\""));
    }
  }

  if (filter.product) {
    domainCategories.push("svs-domain-products/".concat(filter.product));
  }

  var params = {
    count: filter.count,
    domainCategories: domainCategories,
    include: filter.include,
    matchAllDomainCategories: true,
    offset: filter.offset,
    orderBy: 'rank',
    routesDomain: 'partner',
    type: 'cnt:gameAnalysis'
  };
  return basicFilter(params, callback);
}


function getDrawAnalyses(filter, callback) {
  var domainCategories = [];

  if (filter.id) {
    domainCategories.push("svs-domain-sport-draws/".concat(filter.id));
  }

  if (filter.product) {
    domainCategories.push("svs-domain-products/".concat(filter.product));
  }

  var params = {
    count: filter.count,
    domainCategories: domainCategories,
    include: filter.include,
    matchAllDomainCategories: true,
    offset: filter.offset,
    orderBy: 'rank',
    routesDomain: 'partner',
    type: 'cnt:drawAnalysis'
  };
  return basicFilter(params, callback);
}


function getAuthorProfiles(filter, callback) {
  filter = filter || {};
  var domainCategories = [];

  if (filter.product) {
    domainCategories.push("svs-domain-products/".concat(filter.product));
  }

  var params = {
    count: filter.count || 20,
    domainCategories: domainCategories,
    include: filter.include,
    matchAllDomainCategories: true,
    offset: filter.offset,
    orderBy: 'rank',
    routesDomain: 'partner',
    type: 'cnt:authorProfile'
  };
  return basicFilter(params, callback);
}

svs.content.shared.cms = {
  basicFilter: basicFilter,
  getAuthorProfiles: getAuthorProfiles,
  getDrawAnalyses: getDrawAnalyses,
  getGameAnalyses: getGameAnalyses
};
 })(window);